import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';

function init(swiperElement) {
  new Swiper(swiperElement, {
    modules: [FreeMode],
    direction: 'horizontal',
    freeMode: {
      momentum: false,
    },
    slidesPerView: 'auto',
    speed: 0,
    threshold: 0,
    mousewheel: true,
    on: {
      setTranslate: (swiper, translate) => {
        swiperElement.style.setProperty('--offset', `${translate * -1}px`);
      },
    },
  });
}

export function comparisonTable() {
  const swiperElements = document.querySelectorAll('.comparison-table__swiper');
  swiperElements.forEach((element) => init(element));
}
